// Pure helpers for NoticeFromQuery — extract the URL-parsing /
// fingerprinting logic so it can be unit-tested in the node pool.

export interface NoticeProcessing {
  /** Toast message, if a notice was found. */
  notice: string | null;
  /** Path the URL should be cleaned to (param removed). */
  cleanedUrl: string;
  /** Stable identifier so the consumer can avoid double-firing. */
  fingerprint: string | null;
}

// Parse a `?notice=…` param out of the supplied location and return
// the cleaned URL the consumer should navigate to (no `notice=` left
// behind), plus a fingerprint that uniquely identifies the (path,
// notice) pair so React strict-mode double mounts don't fire twice.
export function processNoticeQuery(
  pathname: string,
  search: string,
): NoticeProcessing {
  const params = new URLSearchParams(search);
  const notice = params.get("notice");
  if (!notice) {
    return {
      notice: null,
      cleanedUrl: pathname + (search ?? ""),
      fingerprint: null,
    };
  }
  params.delete("notice");
  const cleanedSearch = params.toString();
  const cleanedUrl = pathname + (cleanedSearch ? `?${cleanedSearch}` : "");
  return {
    notice,
    cleanedUrl,
    fingerprint: `${pathname}::${notice}`,
  };
}
